import $ from "jquery";

var EASE_X1 = 0.25;
var EASE_X2 = 0.25;
var EASE_Y2 = 1;

var ARRAY_TYPE = ('Float32Array' in window) ? Float32Array : Array;

var addEventListener, removeEventListener;

if (typeof document.documentElement.addEventListener == 'function') {
  addEventListener = function (el, evtName, fn) {
    el.addEventListener(evtName, fn);
  };

  removeEventListener = function (el, evtName, fn) {
    el.removeEventListener(evtName, fn);
  };

} else {
  addEventListener = noop;
  removeEventListener = noop;
}

var FIXED_SUPPORTED = false;

(function () {
  var testEl = document.createElement('div');
  var ua = navigator.userAgent;

  testEl.style.position = 'fixed';
  testEl.style.top = 0;

  function checkFixed() {
    var html = document.documentElement;
    var body = window.document.body;
    var scroll = (typeof body.scrollTop !== 'undefined') ? body.scrollTop : html.scrollTop;

    if (scroll !== undefined && scroll > 0 && body) {

      body.insertBefore(testEl, body.firstChild);

      if (!testEl.getBoundingClientRect || testEl.getBoundingClientRect().top !== 0) {
        FIXED_SUPPORTED = false;
      }

      body.removeChild(testEl);

      removeEventListener(window, 'scroll', checkFixed);
    }
  }

  if (
    !(ua.match(/IEMobile\/[0-9]+/))
    &&
    (!(ua.match(/Android 2\.[1256]/) && ua.indexOf('AppleWebKit') > -1)
      || !(ua.match(/Opera Mobi\/([0-9]+)/) && RegExp.$1 < 7458)
      || !(window.operamini && ({}).toString.call(window.operamini) === '[object OperaMini]')
      || !(ua.match(/Fennec\/([0-9]+)/) && RegExp.$1 < 6)
    )
  ) {
    FIXED_SUPPORTED = true;
    addEventListener(window, 'scroll', checkFixed);
  }
})();

function noop() {}

function preventDefault(evt) {
  evt.preventDefault();
  return false;
}

var cssTransformPropNames = {
  'webkitTransform': '-webkit-transform',
  'OTransform': '-o-transform',
  'msTransform': '-ms-transform',
  'MozTransform': '-moz-transform',
  'transform': 'transform'
};

var CSS_TRANSFORM_PROP_NAME = (function () {
  if (!window.getComputedStyle) {
    return null;
  }

  var styles = window.getComputedStyle(document.documentElement);

  if ('transform' in styles) {
    return 'transform';
  }

  for (var propName in cssTransformPropNames) {
    if (cssTransformPropNames.hasOwnProperty(propName) && cssTransformPropNames[propName] in styles) {
      return propName;
    }
  }

  return null;
})();

var CSS_TRANSLATE3D_SUPPORT = CSS_TRANSFORM_PROP_NAME && (function () {
  var el = document.createElement('p');

  var transformPropValue;

  document.documentElement.insertBefore(el, null);

  el.style[CSS_TRANSFORM_PROP_NAME] = 'translate3d(1px,1px,1px)';
  transformPropValue = el.style[CSS_TRANSFORM_PROP_NAME] && window.getComputedStyle(el)
    .getPropertyValue(cssTransformPropNames[CSS_TRANSFORM_PROP_NAME]);

  document.documentElement.removeChild(el);

  return (transformPropValue !== undefined && transformPropValue.length > 0 && transformPropValue !== 'none');
})();

// pomocne funkce

var prefixes = ['ms', 'webkit', 'moz', 'o'];

function polyfill(obj, fnName, polyfillFn) {
  var prefixedFnName;
  var fnNameCap = fnName[0].toUpperCase() + fnName.substr(1);

  if (fnName in obj) {
    return;
  }

  for (var i = 0; i < prefixes.length; i++) {
    prefixedFnName = prefixes[i] + fnNameCap;
    if (prefixedFnName in obj) {
      obj[fnName] = obj[prefixedFnName];
      return;
    }
  }

  obj[fnName] = polyfillFn;
}

function requestAnimationFramePolyfill(fn) {
  return setTimeout(fn, 16.666666666666667);
}

function cancelAnimationFramePolyfill(token) {
  return clearTimeout(token);
}

function assign() {
  var i, key;
  for (i = 1; i < arguments.length; i++) {
    for (key in arguments[i]) {
      if (arguments[i].hasOwnProperty(key)) {
        arguments[0][key] = arguments[i][key];
      }
    }
  }
  return arguments[0];
}

function sign(x) {
  return (x < 0) ? -1 : (x > 0) ? 1 : 0;
}

function clamp(min, max, val) {
  return (val < min) ? min : (val > max) ? max : val;
}

function lerp(a, b, val) {
  return a + (b - a) * val;
}

function valAtX(curvePoints, x) {

  // x rostou, binarysearch
  var min = 0;
  var max = curvePoints.length / 2 - 1;
  var mid;

  while (max - min > 1) {
    mid = Math.floor((max + min) / 2);
    if (curvePoints[mid * 2] < x) {
      min = mid;
    } else {
      max = mid;
    }
  }

  var t = (x - curvePoints[min * 2]) / (curvePoints[max * 2] - curvePoints[min * 2]);
  return lerp(curvePoints[min * 2 + 1], curvePoints[max * 2 + 1], t);
}

function cubicBezierCurve(x1, y1, x2, y2, t, out) {
  var t2 = 1 - t;
  out[0] = 3 * t2 * t2 * t * x1 + 3 * t2 * t * t * x2 + t * t * t;
  out[1] = 3 * t2 * t2 * t * y1 + 3 * t2 * t * t * y2 + t * t * t;
}

/**
 * Vrati funkci, ktera vola funkce fn a immediateFn nejcasteji jednou za animationFrame.
 * Obe se volaji s kontextem thisArg.
 * immediateFn se vola pri volani, fn v pristim framu.
 * @param fn
 * @param thisArg
 * @param [immediateFn]
 * @returns {Function}
 */
function throttle(fn, thisArg, immediateFn) {
  var scheduled = false;
  thisArg = thisArg || window;

  return function () {
    if (scheduled) return;

    var args = new Array(arguments.length);
    for (var i = 0, l = arguments.length; i < l; i++) {
      args[i] = arguments[i];
    }

    if (immediateFn) immediateFn.apply(thisArg, args);

    scheduled = true;
    requestAnimationFrame(function () {
      fn.apply(thisArg, args);
      scheduled = false;
    });
  }
}

/**
 * Memoizace vsech navratovych hodnot na zaklade prvniho primitivniho argumentu
 * @param fn
 * @returns {Function}
 */
function memoize(fn) {
  var cache = {};
  return function memoized(arg) {
    if (!cache.hasOwnProperty(arg)) {
      cache[arg] = fn(arg);
    }
    return cache[arg];
  }
}

var wordRegexp = memoize(function (word) {
  return new RegExp('(?:^|\\s)' + word + '(?:\\s|$)', 'g');
});

function hasClass(el, className) {
  return wordRegexp(className).test(el.className);
}

var addClass, removeClass, toggleClass;

if ('classList' in document.documentElement) {
  addClass = function (el, className) {
    el.classList.add(className);
  };
  removeClass = function (el, className) {
    el.classList.remove(className);
  };
  toggleClass = function (el, className) {
    el.classList.toggle(className);
  };
} else {
  addClass = function (el, className) {
    !hasClass(el, className) && (el.className += ' ' + className);
  };
  removeClass = function (el, className) {
    el.className = el.className.replace(wordRegexp(className), ' ');
  };
  toggleClass = function (el, className) {
    if (hasClass(el, className)) {
      removeClass(el, className);
    } else {
      addClass(el, className);
    }
  };
}

var requestFullscreen, exitFullscreen, isFullscreen;

if (document.exitFullscreen) { // W3C API
  requestFullscreen = function (el) {
    el.requestFullscreen();
  };
  exitFullscreen = function () {
    if (isFullscreen()) document.exitFullscreen();
  };
  isFullscreen = function () {
    return !!document.fullscreenElement;
  };
} else if (document.mozCancelFullScreen) { // Mozilla current API
  requestFullscreen = function (el) {
    el.mozRequestFullScreen();
  };
  exitFullscreen = function () {
    if (isFullscreen()) document.mozCancelFullScreen();
  };
  isFullscreen = function () {
    return document.mozFullScreen;
  };
} else if (document.webkitExitFullscreen) { // Webkit current API
  requestFullscreen = function (el) {
    el.webkitRequestFullscreen();
  };
  exitFullscreen = function () {
    if (isFullscreen()) document.webkitExitFullscreen();
  };
  isFullscreen = function () {
    return document.webkitIsFullScreen;
  };
} else {
  requestFullscreen = exitFullscreen = noop;
  isFullscreen = function () {
    return false;
  };
}

/**
 * Array map
 * @param array
 * @param fn
 * @returns {Array}
 */
function map(array, fn) {
  var out = [];
  for (var i = 0; i < array.length; i++) {
    out.push(fn(array[i], i, array));
  }
  return out;
}

function show(el) {
  // el.style.display = "";
}

function hide(el) {
  // el.style.display = 'none';

  // nelaguje jako display
  setXY(el, 9999, 0);
}

function opacity(el, val) {
  el.style.opacity = val;
}

var setXY = CSS_TRANSLATE3D_SUPPORT
  ? function (el, x, y) {
    el.style[CSS_TRANSFORM_PROP_NAME] = 'translate3d(' + x + 'px, ' + y + 'px, 0)';
  }
  : CSS_TRANSFORM_PROP_NAME
    ? function (el, x, y) {
      el.style[CSS_TRANSFORM_PROP_NAME] = 'translateY(' + y + 'px) translateX(' + x + 'px)';
    }
    : function (el, x, y) {
      el.style.left = Math.round(x) + 'px';
      el.style.top = Math.round(y) + 'px';
    };

/**
 * Vrati x-souradnici, na ktere nastala eventa.
 * @param evt
 * @returns {Number|number}
 */
function eventX(evt) {
  if (evt.touches) {
    return evt.touches[0].clientX;
  } else {
    return evt.clientX;
  }
}

/**
 * Vrati y-souradnici, na ktere nastala eventa.
 * @param evt
 * @returns {Number|number}
 */
function eventY(evt) {
  if (evt.touches) {
    return evt.touches[0].clientY;
  } else {
    return evt.clientY;
  }
}

/**
 * Nascrolluje horizontalne parent tak, aby byl videt jeho potomek child.
 * @param parent
 * @param child
 */
function xScrollIntoView(parent, child) {
  var parentRect = parent.getBoundingClientRect();
  var childRect = child.getBoundingClientRect();
  var containedChildLeft = childRect.left - parentRect.left;
  var containedChildRight = containedChildLeft + childRect.width - parentRect.width;
  if (containedChildLeft < 0) {
    parent.scrollLeft += containedChildLeft;
  } else if (containedChildRight > 0) {
    parent.scrollLeft += containedChildRight;
  }
}

polyfill(window, 'requestAnimationFrame', requestAnimationFramePolyfill);
polyfill(window, 'cancelAnimationFrame', cancelAnimationFramePolyfill);
!('now' in Date) && (Date.now = function () {
  return (new Date()).getTime();
});

/**
 * Cubic bezier easing
 * @param {Object} [options]                 konfigurace
 * @param {Number} [options.curveResolution] jemnost samplovani krivky
 * @param {Number} [options.tableResolution] jemnost samplovani hodnot na krivce
 * @constructor
 */
function CubicBezierEase(options) {
  this.options = assign({}, CubicBezierEase.defaultOptions, options);
  this.curvePoints = new ARRAY_TYPE(this.options.curveResolution * 2);
  this.curveTable = new ARRAY_TYPE(this.options.tableResolution);
}

CubicBezierEase.defaultOptions = {
  curveResolution: 1000,
  tableResolution: 1000
};

/**
 * Nastavi souradnice kontrolnich bodu
 * @param {Number} x1 x-ova souradnice prvniho kontrolniho bodu
 * @param {Number} y1 y-ova souradnice prvniho kontrolniho bodu
 * @param {Number} x2 x-ova souradnice druheho kontrolniho bodu
 * @param {Number} y2 y-ova souradnice druheho kontrolniho bodu
 */
CubicBezierEase.prototype.setPoints = function (x1, y1, x2, y2) {
  // just in case
  x1 = clamp(0, 1, x1);
  x2 = clamp(0, 1, x2);

  if (this.points
    && this.points.x1 === x1
    && this.points.y1 === y1
    && this.points.x2 === x2
    && this.points.y2 === y2) {
    return;
  }

  var i;
  var tmpVec = new ARRAY_TYPE(2);

  for (i = 0; i <= this.options.curveResolution; i++) {
    cubicBezierCurve(x1, y1, x2, y2, i / this.options.curveResolution, tmpVec);
    this.curvePoints[i * 2] = tmpVec[0];
    this.curvePoints[i * 2 + 1] = tmpVec[1];
  }

  for (i = 0; i <= this.options.tableResolution; i++) {
    this.curveTable[i] = valAtX(this.curvePoints, i / this.options.tableResolution);
  }

  this.points = {
    x1: x1,
    y1: y1,
    x2: x2,
    y2: y2
  };
};

/**
 * Vrati hodnotu easing funkce
 * @param {Number} t parametr z intervalu [0, 1]
 * @returns {Number}
 */
CubicBezierEase.prototype.value = function (t) {
  if (t <= 0) {
    return this.curveTable[0];
  }
  if (t >= 1) {
    return this.curveTable[this.options.tableResolution + 1];
  }
  var tableIndex = t * this.options.tableResolution;
  var tableIndexFloor = Math.floor(tableIndex);
  var lerpT = tableIndex - tableIndexFloor;
  return lerp(this.curveTable[tableIndexFloor], this.curveTable[tableIndexFloor + 1], lerpT);
};

/**
 * Udela element horizontalne posouvatelny mysi namisto scrollbaru. Mj. nastavi overflow: hidden.
 * @param el
 */
function dragScroll(el) {
  var dragOrigin = 0;
  var scrollOrigin = 0;

  el.style.overflow = 'hidden';

  function onMove(evt) {
    evt.preventDefault();
    el.scrollLeft = scrollOrigin - eventX(evt) + dragOrigin;
  }

  var onMoveThrottled = throttle(onMove);

  function onStop() {
    removeEventListener(document, 'mousemove', onMoveThrottled);
    //removeEventListener(document, 'touchmove', onMoveThrottled);
    removeEventListener(document, 'mouseup', onStop);
    //removeEventListener(document, 'touchend', onStop);
    //removeEventListener(document, 'touchcancel', onStop);
    removeClass(el, 'grabbing');
  }

  function onStart(evt) {
    addClass(el, 'grabbing');
    dragOrigin = eventX(evt);
    scrollOrigin = el.scrollLeft;
    addEventListener(document, 'mousemove', onMoveThrottled);
    //addEventListener(document, 'touchmove', onMoveThrottled);
    addEventListener(document, 'mouseup', onStop);
    //addEventListener(document, 'touchend', onStop);
    //addEventListener(document, 'touchcancel', onStop);
    evt.preventDefault();
  }

  addEventListener(el, 'mousedown', onStart);
  //addEventListener(el, 'touchstart', onStart);

  addEventListener(el, 'touchstart', function () {
    el.style.overflow = 'auto';
    removeEventListener(el, 'mousedown', onStart);
    removeEventListener(el, 'mouseup', onStop);
    removeEventListener(el, 'mousemove', onMove);
  });
}

var uid = 1;

/**
 * PopupGallery
 * @param {Object[]} images
 * @param {Object} [options]
 * @constructor
 */
function PhotoViewer(images, options) {
  this.id = uid++;

  if (typeof document.body.addEventListener != 'function') {
    for (var methodName in PhotoViewer.prototype) {
      if (PhotoViewer.prototype.hasOwnProperty(methodName) && typeof PhotoViewer.prototype[methodName] == 'function') {
        this[methodName] = noop;
      }
    }
    this.supportedPlatform = false;
    return;
  }

  this.supportedPlatform = true;

  var self = this;
  var initialImageState = {loaded: false};
  var i;

  this.fireAnimationTick = function () {
    self.animationTick();
  };

  this.onClose = noop;
  this.onChangeIndex = noop;

  this.options = assign({}, PhotoViewer.defaultOptions, options);

  if (this.options.showThumbs === null) {
    this.options.showThumbs = images.length > 1;
  }

  if (this.options.draggable === null) {
    this.options.draggable = images.length > 1;
  }

  this.curve = new CubicBezierEase(this.options.curveOptions);

  this.images = [];
  for (i = 0; i < images.length; i++) {
    this.images.push(assign({id: i}, images[i], initialImageState));
  }

  this.windowEvents = {
    resize: function () {
      self.handleResize();
    },
    hashchange: function (evt) {
      self.handleHashChange(evt);
    }
  };
  this.bindWindowEvents();

  this.currentOperation = null;

  this.zoom = 0;
  this.fullscreen = false;
  this.pan = {x: 0, y: 0};

  this.template = new VOID.Template();
  this.template.addTemplate('base', document.getElementById(this.options.template).innerHTML); // TODO: abstrahovat

  this.costructDOM();
  // this.close(); // don't call it here, since it's called from handleHashchange bellow and this call messes with the hash

  if (!this.options.showThumbs) {
    hide(this.thumbsEl);
    removeClass(self.thumbsEl, 'on');
    addClass(self.thumbsEl, 'off');
  }

  this.ignoreNextHashchange = false;

  this.handleHashChange();
}

PhotoViewer.defaultOptions = {
  curveOptions: {
    curveResolution: 1000,
    tableResolution: 1000
  },
  positionThreshold: 0.25, // zlomek sirky aktualniho obrazku
  speedThreshold: 0.25, // px/ms
  minTransitionTime: 500,
  showThumbs: null,
  draggable: null,
  zoomSteps: [1, 1.5, 2, 2.5, 3]
};

/**
 * Skoci na dany index bez animace.
 * @param {Number} index
 * @public
 */
PhotoViewer.prototype.goTo = function (index) {
  var image = this.images[index];

  if (this.currentOperation && this.currentOperation.type === 'animation') {
    cancelAnimationFrame(this.currentOperation.token);
    this.currentOperation = null;
  }

  for (var i = 0; i < this.images.length; i++) {

    // skryt ostatni obrazky
    if (i !== index) {
      hide(this.images[i].el);
    }

    // nacist jeden pred az jeden za
    if (i >= index - 1 && i <= index + 1) {
      this.ensureLoad(i);
    }
  }

  this.position = image.snapPoint;
  this.setCurrentIndex(index);
  this.setZoom(0);
  this.updateActiveImagePosition();
  opacity(image.el, 1);
  show(image.el);
};

/**
 * @public
 */
PhotoViewer.prototype.close = function () {
  removeEventListener(window, 'keydown', this.windowEvents.onKeydown);
  delete this.windowEvents.onKeydown;
  this.isOpen = false;
  this.exitFullscreen();
  removeClass(this.el, 'lb_open');
  if (this.readIndexFromHash() !== null) history.back();
  this.onClose();

  document.body.style.height = "";
  document.body.style.overflow = "";
};

/**
 * Otevre galerii bud na prvnim obrazku nebo na zadanem indexu.
 * @param {Number} [index = 0]
 * @public
 */
PhotoViewer.prototype.open = function (index) {
  var self = this;

  this.zoom = 0;

  if (this.isOpen) {
    return;
  }

  if (!FIXED_SUPPORTED) {
    addClass(this.el, 'lb_no-fixed');
  }

  this.updateWindowDependentDimensions();

  this.windowEvents.onKeydown = function (evt) {
    self.handleKeyboard(evt);
  };

  addEventListener(window, 'keydown', this.windowEvents.onKeydown);

  this.goTo(index || 0);
  this.isOpen = true;
  addClass(this.el, 'lb_open');

  document.body.style.height = window.innerHeight + 'px';
  document.body.style.overflow = 'hidden';
};

/**
 * @public
 */
PhotoViewer.prototype.enterFullscreen = function () {
  requestFullscreen(this.el);
  addClass(this.el, 'full');
  this.fullscreen = true;
};

/**
 * @public
 */
PhotoViewer.prototype.exitFullscreen = function () {
  exitFullscreen();
  removeClass(this.el, 'full');
  this.fullscreen = false;
};

/**
 * @public
 */
PhotoViewer.prototype.toggleFullscreen = function () {
  if (this.fullscreen) this.exitFullscreen();
  else this.enterFullscreen();
};

/**
 * Helper, ktery navaze otevreni instance na click eventy danych elementu
 * @param {HTMLElement[]|HTMLCollection} clickables
 * @public
 */
PhotoViewer.prototype.bindClickEvents = function (clickables) {
  var self = this;

  // clickables.length !== this.images.length by byla chyba, ale just in case
  var len = Math.min(clickables.length, this.images.length);

  for (var i = 0; i < len; i++) {
    (function (i) {
      addEventListener(clickables[i], 'click', function (evt) {
        self.open(i);
        evt.preventDefault();
        return false;
      });
    })(i);
  }
};

/**
 * Resizuje obrazek na danem indexu s ohledem na rozmery okna cachovane v this.dimensions.
 * @param index
 * @private
 */
PhotoViewer.prototype.updateImageSize = function (index) {
  var image = this.images[index];
  var scale = Math.min(this.dimensions.winWidth / image.width, this.dimensions.winHeight / image.height);

  if (scale < 1) { // musime zmensovat
    image.displayWidth = scale * image.width;
    image.displayHeight = scale * image.height;
  } else {
    image.displayWidth = image.width;
    image.displayHeight = image.height;
  }

  image.displayWidth *= this.options.zoomSteps[this.zoom];
  image.displayHeight *= this.options.zoomSteps[this.zoom];

  image.el.style.width = Math.floor(image.displayWidth) + 'px';
  image.el.style.height = Math.floor(image.displayHeight) + 'px';
};

/**
 * Nastavi zoom na hodnotu this.options.zoom[zoom].
 * @param zoom
 * @private
 */
PhotoViewer.prototype.setZoom = function (zoom) {
  var maxZoom = this.options.zoomSteps.length - 1;
  this.zoom = clamp(0, maxZoom, zoom);
  this.updateImageSize(this.currentIndex);
  this.clampPan();
  this.updateActiveImagePosition();

  if (this.zoom == maxZoom) {
    addClass(this.zoomInBtn, 'dis'); // TODO: abstrahovat
  } else {
    removeClass(this.zoomInBtn, 'dis');
  }

  if (this.zoom == 0) {
    addClass(this.zoomOutBtn, 'dis'); // TODO: abstrahovat
  } else {
    removeClass(this.zoomOutBtn, 'dis');
  }
};

/**
 * Nastavi zoom na nasledujici hodnotu v poli this.options.zoom.
 * @private
 */
PhotoViewer.prototype.zoomIn = function () {
  this.setZoom(this.zoom + 1);
};

/**
 * Nastavi zoom na predchozi hodnotu v poli this.options.zoom.
 * @private
 */
PhotoViewer.prototype.zoomOut = function () {
  this.setZoom(this.zoom - 1);
};

/**
 * Nastavi vsechny rozmery zavisle na velikosti okna. K zavolani vzdy po otevreni nebo zmene velikosti okna.
 * @public
 */
PhotoViewer.prototype.updateWindowDependentDimensions = function () {
  var winWidth = window.innerWidth;
  var winHeight = window.innerHeight;
  var snapPoint = 0;
  var image;
  var i;

  if (!FIXED_SUPPORTED) {
    // TODO: co tady?
    // this.wrapperEl.style.height = winHeight + 'px';
    // this.wrapperEl.style.top = window.pageYOffset + 'px';
    // this.el.style.height = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight) + 'px';
  }

  // cache
  this.dimensions = {
    winWidth: winWidth,
    winHeight: winHeight
  };

  for (i = 0; i < this.images.length; i++) {
    image = this.images[i];
    this.updateImageSize(i);

    snapPoint = image.snapPoint = ((i !== 0) ? this.images[i - 1].displayWidth / 2 : 0) + snapPoint + image.displayWidth / 2;
    //image.snapPoint = i * winWidth;
  }
};

/**
 * Animuje na dany index.
 * @param index
 * @public
 */
PhotoViewer.prototype.animateTo = function (index) {
  index = clamp(0, this.images.length - 1, index);

  if (this.currentOperation && this.currentOperation.type === 'drag') {
    var speed = this.currentOperation.speed;
  } else if (this.currentOperation && this.currentOperation.type === 'animation') {
    // TODO: merit rychlost behem animace
    speed = 0;
    cancelAnimationFrame(this.currentOperation.token);
  } else {
    speed = 0;
  }

  var distanceToAnimate = this.position - this.images[index].snapPoint;

  if (distanceToAnimate == 0) {
    this.currentOperation = null;
    if (this.currentIndex !== index) {
      this.goTo(index);
    }
    return;
  }

  var transitionDuration = this.options.minTransitionTime;
  var easeY1 = (distanceToAnimate != 0) ? -speed * EASE_X1 * this.options.minTransitionTime / distanceToAnimate : 0;
  var maxEaseY1 = Math.min(2 * EASE_X1, 1); // min kvuli predejiti bouncovani kdyby EASE_X1 bylo vysssi nez 0.5

  if (easeY1 > maxEaseY1) {
    transitionDuration /= (easeY1 / maxEaseY1);
    easeY1 = maxEaseY1;
  }

  this.curve.setPoints(EASE_X1, easeY1, EASE_X2, EASE_Y2);

  this.currentOperation = {
    type: 'animation',
    positionOrigin: this.position,
    duration: transitionDuration,
    target: index,
    startTime: Date.now(),
    progress: 0
  };

  this.animationTick();
};

/**
 * Animuje na predchozi index
 * @param {Boolean} [force] jestli pripadne prerusit probihajici animaci/interakci (jinak return)
 * @public
 */
PhotoViewer.prototype.prev = function (force) {
  this.setZoom(0);
  var target = (this.currentOperation && this.currentOperation.type === 'animation') ? this.currentOperation.target - 1 : this.currentIndex - 1;
  if (target >= 0 && (force || this.shouldHandlePrevNext())) {
    this.animateTo(target);
  }
};

/**
 * Animuje na nasledujici index
 * @param {Boolean} [force] jestli pripadne prerusit probihajici animaci/interakci (jinak return)
 * @public
 */
PhotoViewer.prototype.next = function (force) {
  this.setZoom(0);
  var target = (this.currentOperation && this.currentOperation.type === 'animation') ? this.currentOperation.target + 1 : this.currentIndex + 1;
  if (target < this.images.length && (force || this.shouldHandlePrevNext())) {
    this.animateTo(target);
  }
};

/**
 * Jestli prave neprobiha animace/interakce.
 * @returns {boolean}
 * @private
 */
PhotoViewer.prototype.shouldHandlePrevNext = function () {
  // nereagovat na kliknuti na sipky, pokud prave dragujeme nebo animujeme
  return Math.abs(this.position - this.images[this.currentIndex].snapPoint) < 10;
};

/**
 * Jeden tik animace. Vola sam sebe dokud neni animace hotova.
 * @private
 */
PhotoViewer.prototype.animationTick = function () {
  var currentTime = Date.now();
  var timeProgress = (currentTime - this.currentOperation.startTime) / this.currentOperation.duration;
  var targetIndex = this.currentOperation.target;
  var targetImage = this.images[targetIndex];
  var progress;

  if (timeProgress < 1) {
    this.currentOperation.token = requestAnimationFrame(this.fireAnimationTick);
    progress = this.curve.value(timeProgress);

    // set index in the middle of animation
    if (this.currentOperation.progress < .5 && progress >= .5) {
      this.setCurrentIndex(this.currentOperation.target);
    }

    this.setPosition(lerp(this.currentOperation.positionOrigin, targetImage.snapPoint, progress));

    this.currentOperation.progress = progress;
  } else {
    this.goTo(targetIndex);
    this.currentOperation = null;
  }
};

/**
 * Event handler pro resize okna.
 * @private
 */
PhotoViewer.prototype.handleResize = function () {
  if (this.isOpen) {
    this.setZoom(0);
    this.updateWindowDependentDimensions();
    if (!this.currentOperation) {
      this.position = this.images[this.currentIndex].snapPoint;
      this.updateActiveImagePosition();
    } else if (this.currentOperation.type === 'animation') {
      this.goTo(this.currentOperation.target);
    } else {
      this.position = this.images[this.currentIndex].snapPoint;
      this.updateActiveImagePosition();
      this.currentOperation = null;
    }
  }
};

/**
 * Hodnoty v this.pan omezi tak, aby obrazek nebyl pretazen zbytecne daleko od kraje okna.
 * @private
 */
PhotoViewer.prototype.clampPan = function () {
  var image = this.images[this.currentIndex];

  var maxPanX = Math.max(0, (image.displayWidth - this.dimensions.winWidth) / 2);
  var maxPanY = Math.max(0, (image.displayHeight - this.dimensions.winHeight) / 2);

  this.pan.x = clamp(-maxPanX, maxPanX, this.pan.x);
  this.pan.y = clamp(-maxPanY, maxPanY, this.pan.y);
};

/**
 * Event handler pro mousemove behem zoomu.
 * @param evt
 * @private
 */
PhotoViewer.prototype.handlePanMove = function (evt) {
  this.pan.x = this.currentOperation.panOrigin.x + eventX(evt) - this.currentOperation.dragOrigin.x;
  this.pan.y = this.currentOperation.panOrigin.y + eventY(evt) - this.currentOperation.dragOrigin.y;

  this.clampPan();

  this.updateActiveImagePosition();

  evt.preventDefault();
};

/**
 * Event handler pro mousedown behem zoomu.
 * @param evt
 * @private
 */
PhotoViewer.prototype.handlePanStart = function (evt) {
  var self = this;

  this.currentOperation = {
    type: 'pan',
    dragOrigin: {x: eventX(evt), y: eventY(evt)},
    panOrigin: {x: this.pan.x, y: this.pan.y}
  };

  var onPanMove = throttle(this.handlePanMove, this, preventDefault);

  function onPanEnd() {
    removeClass(self.sliderEl, 'grabbing');
    removeEventListener(document, 'touchmove', onPanMove);
    removeEventListener(document, 'mousemove', onPanMove);
    removeEventListener(document, 'touchend', onPanEnd);
    removeEventListener(document, 'touchcancel', onPanEnd);
    removeEventListener(document, 'mouseup', onPanEnd);
  }

  addEventListener(document, 'touchmove', onPanMove);
  addEventListener(document, 'mousemove', onPanMove);
  addEventListener(document, 'touchend', onPanEnd);
  addEventListener(document, 'touchcancel', onPanEnd);
  addEventListener(document, 'mouseup', onPanEnd);

  addClass(this.sliderEl, 'grabbing');

  evt.preventDefault();
};

/**
 * Event handler pro mousedown
 * @param evt
 * @private
 */
PhotoViewer.prototype.handleDragStart = function (evt) {
  var self = this;

  if (this.zoom > 0) {
    this.handlePanStart(evt);
    return;
  }

  if (!this.options.draggable) return;

  if (this.currentOperation && this.currentOperation.type === 'animation') {
    cancelAnimationFrame(this.currentOperation.token);
  }

  this.currentOperation = {
    type: 'drag',
    dragOrigin: eventX(evt),
    positionOrigin: this.position,
    speed: 0,
    lastSpeedRecordTime: Date.now(),
    lastPosition: this.position
  };

  var onDragMove = throttle(this.handleDragMove, this);

  function onDragEnd() {
    self.handleDragEnd();
    removeEventListener(document, 'touchmove', onDragMove);
    removeEventListener(document, 'mousemove', onDragMove);
    removeEventListener(document, 'touchend', onDragEnd);
    removeEventListener(document, 'touchcancel', onDragEnd);
    removeEventListener(document, 'mouseup', onDragEnd);
  }

  addEventListener(document, 'touchmove', onDragMove);
  addEventListener(document, 'mousemove', onDragMove);
  addEventListener(document, 'touchend', onDragEnd);
  addEventListener(document, 'touchcancel', onDragEnd);
  addEventListener(document, 'mouseup', onDragEnd);

  addClass(this.sliderEl, 'grabbing');

  evt.preventDefault();
};

/**
 * Event handler pro mousemove behem dragovani
 * @param evt
 * @private
 */
PhotoViewer.prototype.handleDragMove = function (evt) {
  if (!this.currentOperation) return; // throttled call
  var currentTime = Date.now();
  var currentDragPosition = eventX(evt);
  var firstSnapPoint = this.images[0].snapPoint;
  var lastSnapPoint = this.images[this.images.length - 1].snapPoint;
  var prevSnapPoint = this.currentIndex > 0 ? this.images[this.currentIndex - 1].snapPoint : -Infinity;
  var nextSnapPoint = this.currentIndex < this.images.length - 1 ? this.images[this.currentIndex + 1].snapPoint : Infinity;
  var newPosition = this.currentOperation.positionOrigin - currentDragPosition + this.currentOperation.dragOrigin;

  if (this.currentIndex === 0 && newPosition < firstSnapPoint) {
    this.setPosition((newPosition + firstSnapPoint) / 2);
  } else if (this.currentIndex === (this.images.length - 1) && newPosition > lastSnapPoint) {
    this.setPosition((newPosition + lastSnapPoint) / 2);
  } else {
    this.setPosition(clamp(prevSnapPoint, nextSnapPoint, newPosition));
  }

  this.currentOperation.speed = (this.position - this.currentOperation.lastPosition) / (currentTime - this.currentOperation.lastSpeedRecordTime);
  this.currentOperation.lastSpeedRecordTime = currentTime;
  this.currentOperation.lastPosition = this.position;

  evt.preventDefault();
};

/**
 * Event handler pro mouseup behem dragovani
 * @private
 */
PhotoViewer.prototype.handleDragEnd = function () {
  var currentImage = this.images[this.currentIndex];
  var positionThresholdPx = currentImage.displayWidth * this.options.positionThreshold;
  var distanceDragged = this.position - currentImage.snapPoint;
  var speed = this.currentOperation.speed;
  var speedThreshold = this.options.speedThreshold;

  if (sign(distanceDragged) === -sign(speed)) {
    // jsme vlevo ale trhame doprava / naopak
    this.animateTo(this.currentIndex);
  } else if (distanceDragged < -positionThresholdPx || speed < -speedThreshold) {
    // jsme vlevo nebo trhame silne doleva
    this.animateTo(this.currentIndex - 1);

  } else if (distanceDragged > positionThresholdPx || speed > speedThreshold) {
    // jsme vpravo nebo trhame silne doprava
    this.animateTo(this.currentIndex + 1);

  } else {
    this.animateTo(this.currentIndex);
  }

  removeClass(this.sliderEl, 'grabbing');
};

/**
 * Napozicuje obrazek na danem indexu s ohledem na pozici dragu/animace.
 * @param index
 * @private
 */
PhotoViewer.prototype.positionImage = function (index) {
  var image = this.images[index];
  setXY(image.el,
    this.dimensions.winWidth / 2 - image.displayWidth / 2 - this.position + image.snapPoint,
    this.dimensions.winHeight / 2 - image.displayHeight / 2
  );
};

/**
 * Nastavi pozici dragu/animace.
 * @param position
 * @private
 */
PhotoViewer.prototype.setPosition = function (position) {
  var firstSnapPoint = this.images[0].snapPoint;
  var lastSnapPoint = this.images[this.images.length - 1].snapPoint;
  var leftImageIndex, rightImageIndex, leftImage, rightImage, i, image, progress;

  this.position = position;

  if (position < firstSnapPoint) {

    // skryt ostatni
    for (i = 1; i < this.images.length; i++) {
      hide(this.images[i].el);
    }

    image = this.images[0];
    opacity(image.el, 1);
    this.positionImage(0);
    show(image.el);
  } else if (position > lastSnapPoint) {

    // skryt ostatni
    for (i = 0; i < this.images.length - 1; i++) {
      hide(this.images[i].el);
    }

    image = this.images[this.images.length - 1];
    opacity(image.el, 1);
    this.positionImage(this.images.length - 1);
    show(image.el);
  } else {

    // snapPoint rostou, binarysearch
    leftImageIndex = 0;
    rightImageIndex = this.images.length - 1;
    var mid;

    while (rightImageIndex - leftImageIndex > 1) {
      mid = Math.floor((rightImageIndex + leftImageIndex) / 2);
      if (this.images[mid].snapPoint < position) {
        leftImageIndex = mid;
      } else {
        rightImageIndex = mid;
      }
    }

    // skryt ostatni
    for (i = 0; i < leftImageIndex; i++) {
      hide(this.images[i].el);
    }

    for (i = rightImageIndex + 1; i < this.images.length; i++) {
      hide(this.images[i].el);
    }

    leftImage = this.images[leftImageIndex];
    rightImage = this.images[rightImageIndex];

    progress = (position - leftImage.snapPoint) / (rightImage.snapPoint - leftImage.snapPoint);

    opacity(leftImage.el, 1 - progress);
    opacity(rightImage.el, progress);

    this.positionImage(leftImageIndex);
    this.positionImage(rightImageIndex);

    show(leftImage.el);
    show(rightImage.el);
  }
};

/**
 * Provede veskerou signalizaci prechodu na dany index (neprovadi ale samotny prechod, to dela goTo).
 * @param index
 * @private
 */
PhotoViewer.prototype.setCurrentIndex = function (index) {
  if (typeof this.currentIndex !== 'undefined') {
    removeClass(this.images[this.currentIndex].thumbEl.getElementsByTagName('img')[0], 'active'); // TODO: abstrahovat
  }
  var activeThumbEl = this.images[index].thumbEl;
  addClass(activeThumbEl.getElementsByTagName('img')[0], 'active');

  if (index === this.images.length - 1) {
    addClass(this.el, 'last');
  } else {
    removeClass(this.el, 'last');
  }

  if (index === 0) {
    addClass(this.el, 'first');
  } else {
    removeClass(this.el, 'first');
  }

  if (FIXED_SUPPORTED) {
    xScrollIntoView(activeThumbEl.parentNode, activeThumbEl);
  }

  this.onChangeIndex(index);
  this.currentIndex = index;
  this.cntEl.innerText = (index + 1) + '/' + this.images.length;
  var hash = '#' + this.getHash();
  var isHashSet = this.readIndexFromHash() !== null;
  if (location.hash != hash) {
    this.ignoreNextHashchange = true;
    if (isHashSet) location.replace(hash); // don't add to history
    else location.hash = hash;
  }
};

/**
 * Vrati hash reprezentujici prave otevreny obrazek
 * @returns {string}
 */
PhotoViewer.prototype.getHash = function () {
  return "image-" + this.id + "-" + this.currentIndex;
};

/**
 * Precte index obrazku z hashe, pokud reprezentuje nejaky obrazek teto instance. Jinak null;
 * @returns {number|null}
 */
PhotoViewer.prototype.readIndexFromHash = function () {
  var hash = location.hash;
  if (!hash) return null;
  var match = /#image-(\d+)-(\d+)/.exec(hash);
  if (!match) return null;
  if (match[1] != this.id) return null;
  return parseInt(match[2]);
};

PhotoViewer.prototype.handleHashChange = function () {
  var ignore = this.ignoreNextHashchange;
  this.ignoreNextHashchange = false;
  if (ignore) return;
  var index = this.readIndexFromHash();
  if (index === null) this.close();
  else {
    this.open();
    this.goTo(index);
  }
};

/**
 * Napozicuje aktualni obrazek bez ohledu na pozici dragu/animace. K volani napr. po resize okna nebo dokonceni akce.
 * @private
 */
PhotoViewer.prototype.updateActiveImagePosition = function () {
  var image = this.images[this.currentIndex];

  setXY(image.el,
    Math.round(this.dimensions.winWidth / 2 - image.displayWidth / 2 + this.pan.x),
    Math.round(this.dimensions.winHeight / 2 - image.displayHeight / 2 + this.pan.y)
  );
};

/**
 * Event handler pro klavesy
 * @param {Event} evt
 * @private
 */
PhotoViewer.prototype.handleKeyboard = function (evt) {
  switch (evt.which) {
    case 37:
      this.prev(true);
      break;

    case 39:
      this.next(true);
      break;

    case 27:
      this.close();
      break;

    case 107:
      this.zoomIn();
      break;

    case 109:
      this.zoomOut();
      break;
  }
};

/**
 * Vyrobi cely DOM, nabinduje eventy a appendne ho do body.
 * @private
 */
PhotoViewer.prototype.costructDOM = function () {
  var self = this;
  var helper = document.createElement('div');

  helper.innerHTML = this.template.parse('base', {
    slides: map(this.images, function (image) {
      return self.template.parse('image', image);
    }).join(''),
    thumbs: map(this.images, function (image) {
      return self.template.parse('thumb', image);
    }).join('')
  });

  this.el = helper.getElementsByTagName('div')[0];
  document.body.appendChild(this.el);

  this.sliderEl = document.getElementById('lb_slides');
  this.thumbsEl = document.getElementById('lb_b');
  this.cntEl = document.getElementById('lb_cnt');
  this.captionEl = document.getElementById('lb_caption');
  if (this.options.title) {
    this.captionEl.innerText = this.options.title || '';
  } else {
    this.captionEl.style.display = 'none';
  }

  // thumbs scroll
  dragScroll(this.thumbsEl.getElementsByClassName('thmb')[0]); // TODO: abstrahovat

  // button events
  addEventListener(document.getElementById('lb_prev'), 'click', function (evt) {
    self.prev();
    evt.preventDefault();
  });
  addEventListener(document.getElementById('lb_next'), 'click', function (evt) {
    self.next();
    evt.preventDefault();
  });
  addEventListener(document.getElementById('lb_close'), 'click', function (evt) {
    self.close();
    evt.preventDefault();
  });
  addEventListener(this.zoomInBtn = document.getElementById('lb_zin'), 'click', function (evt) {
    self.zoomIn();
    evt.preventDefault();
  });
  addEventListener(this.zoomOutBtn = document.getElementById('lb_zout'), 'click', function (evt) {
    self.zoomOut();
    evt.preventDefault();
  });
  addEventListener(document.getElementById('lb_thumbToggle'), 'click', function () {
    toggleClass(self.thumbsEl, 'on'); // TODO: abstrahovat
    toggleClass(self.thumbsEl, 'off');
  });

  var fullBtn = document.getElementById('lb_full');

  if (requestFullscreen != noop) {
    addEventListener(fullBtn, 'click', function (evt) {
      self.toggleFullscreen();
      evt.preventDefault();
    });
  } else {
    fullBtn.style.display = 'none';
  }

  // drag events
  var sliderEl = document.getElementById('lb_slides');
  addEventListener(sliderEl, 'touchstart', function (evt) {
    self.handleDragStart(evt);
  });
  addEventListener(sliderEl, 'mousedown', function (evt) {
    self.handleDragStart(evt);
  });

  if (this.options.draggable) addClass(this.el, 'draggable'); // TODO: abstrahovat

  var i, image;
  // images and thumbs
  for (i = 0; i < this.images.length; i++) {
    image = this.images[i];
    image.el = document.getElementById('lb_img_' + i);
    image.thumbEl = document.getElementById('lb_thumb_' + i);
    addEventListener(image.thumbEl, 'click', (function (index) {
      return function (evt) {
        self.goTo(index);
        evt.preventDefault();
      }
    })(i));

    // fix pro firefox, kde se mysi zacne dragovat obrazek
    addEventListener(document.getElementById('lb_preview_' + i), 'mousedown', preventDefault);
  }
};

/**
 * Zajisti nacteni plne verze obrazku na danem indexu.
 * @param {Number} index
 * @private
 */
PhotoViewer.prototype.ensureLoad = function (index) {
  var image = this.images[index];
  var imageEl;
  if (!image.loaded) {
    imageEl = document.createElement('img');
    imageEl.src = image.url;

    // fix pro firefox, kde se mysi zacne dragovat obrazek
    addEventListener(imageEl, 'mousedown', preventDefault);

    image.el.appendChild(imageEl);
    image.loaded = true;
  }
};

/**
 * Nabinduje vsechny eventy z interniho objektu this.windowEvents na window.
 * @private
 */
PhotoViewer.prototype.bindWindowEvents = function () {
  for (var evtName in this.windowEvents) {
    if (this.windowEvents.hasOwnProperty(evtName)) {
      addEventListener(window, evtName, this.windowEvents[evtName]);
    }
  }
};

/**
 * Odbinduje vsechny eventy z interniho objektu this.windowEvents z window.
 * @private
 */
PhotoViewer.prototype.unbindWindowEvents = function () {
  for (var evtName in this.windowEvents) {
    if (this.windowEvents.hasOwnProperty(evtName)) {
      removeEventListener(window, evtName, this.windowEvents[evtName]);
    }
  }
};

PhotoViewer.prototype.destroy = function () {
  this.el.parentNode.removeChild(this.el);
  this.unbindWindowEvents();
};

export {PhotoViewer};

// DOM auto-initialization

$(function() {
  const groups = {};
  const getGroup = name => groups[name] || (groups[name] = []);

  $("[data-photo-viewer]").each((i, el) => {
    const $el = $(el);
    const [group, thumbWidth, thumbHeight, width, height] = $el.attr("data-photo-viewer").split(",");
    const url = $el.attr("href");
    const thumbUrl = $el.find("img").attr("src");
    getGroup(group).push([{ thumbUrl, thumbWidth, thumbHeight, url, width, height}, $el]);
  });

  let currentGroup = "";
  let viewer = null;

  Object.keys(groups).forEach(group => {
    groups[group].forEach((g, i) => {
      g[1].on("click", $evt => {
        if (currentGroup !== group) {
          if (viewer) viewer.destroy();
          viewer = new PhotoViewer(groups[group].map(i => i[0]), { template: "photoViewerTemplate", title: "" });
        }
        viewer.open(i);
        $evt.preventDefault();
      });
    });
  });
});
